import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';

const PRODUCT_LABELS = {
  tshirt: 'T-Shirt',
  mug: 'Mug',
  poster: 'Poster',
  totebag: 'Tote Bag',
  casquette: 'Cap'
};

const AvailableProducts = ({ products, compact = false }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { t } = useLanguage();

  const isAllProducts = !products || typeof products !== 'object' || Object.keys(products).length === 0;
  const availableList = isAllProducts
    ? Object.values(PRODUCT_LABELS)
    : Object.entries(products)
        .filter(([, val]) => val)
        .map(([key]) => PRODUCT_LABELS[key] || key);

  const allTrue = !isAllProducts && Object.values(products).every(v => v);
  const countLabel = (isAllProducts || allTrue)
    ? t('availableTypeAll')
    : `${t('availableType')} (${availableList.length})`;

  return (
    <div
      className="relative"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div className={`flex items-center justify-between ${compact ? 'px-2 py-1.5' : 'px-3 py-2'} bg-gray-800/60 rounded-lg border border-gray-600/40 cursor-default`}>
        <span className="text-xs text-gray-300 font-medium">
          {countLabel}
        </span>
        <div className={`${compact ? 'w-4 h-4 ml-1.5' : 'w-5 h-5 ml-2'} rounded-full bg-gray-600/80 flex items-center justify-center flex-shrink-0`}>
          <svg className={`${compact ? 'w-2.5 h-2.5' : 'w-3 h-3'} text-gray-300`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01" />
          </svg>
        </div>
      </div>

      {showTooltip && (
        <div
          className="absolute z-50 bottom-full mb-2 left-0 min-w-[160px] bg-gray-900 border border-gray-600 rounded-lg shadow-xl p-3"
        >
          <p className="text-xs font-semibold text-gray-400 mb-2 uppercase tracking-wider">{t('availableFor')}</p>
          <div className="flex flex-wrap gap-1.5">
            {availableList.map((name) => (
              <span
                key={name}
                className="text-xs bg-cyan-600/30 text-cyan-300 border border-cyan-500/30 px-2 py-0.5 rounded-full font-medium"
              >
                {name}
              </span>
            ))}
          </div>
          {isAllProducts && (
            <p className="text-xs text-gray-500 mt-2 italic">{t('noRestrictions')}</p>
          )}
        </div>
      )}
    </div>
  );
};

export default AvailableProducts;
